import { useMemo } from 'react';
import { Gauge, Car, Calendar, MapPin, Settings, Shield } from 'lucide-react';
import { isAndroidDevice } from '../utils/platform';

const BASE_TABS = [
  { id: 'dashboard', label: 'Dashboard', Icon: Gauge },
  { id: 'garage', label: 'Garage', Icon: Car },
  { id: 'events', label: 'Events', Icon: Calendar },
  { id: 'routes', label: 'Routes', Icon: MapPin },
  { id: 'settings', label: 'Settings', Icon: Settings },
];

export default function BottomNav({ activeTab, onChangeTab, pendingInvitationCount = 0, hiddenTabs = [], showClubAdmin = false }) {
  const tabs = useMemo(() => {
    let result = hiddenTabs.length === 0 ? [...BASE_TABS] : BASE_TABS.filter(tab => !hiddenTabs.includes(tab.id));
    if (showClubAdmin) {
      const settingsIdx = result.findIndex(t => t.id === 'settings');
      const clubTab = { id: 'club_admin', label: 'Club Admin', Icon: Shield };
      if (settingsIdx >= 0) {
        result = [...result.slice(0, settingsIdx), clubTab, ...result.slice(settingsIdx)];
      } else {
        result = [...result, clubTab];
      }
    }
    return result;
  }, [hiddenTabs, showClubAdmin]);

  return (
    <nav
      className="app-nav"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        maxWidth: 480,
        margin: '0 auto',
        background: 'var(--bg-card)',
        borderTop: '1px solid var(--border)',
        display: 'flex',
        paddingBottom: isAndroidDevice ? '4px' : 'max(4px, env(safe-area-inset-bottom))',
        zIndex: 100,
      }}
    >
      {/* Logo — visible only on desktop sidebar */}
      <div
        className="desktop-only"
        style={{
          padding: '8px 24px 24px',
          borderBottom: '1px solid var(--border)',
          marginBottom: 8,
        }}
      >
        <img
          src="/logo-wide.png"
          alt="Proper Miles"
          style={{ height: 28, objectFit: 'contain' }}
        />
      </div>

      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            className="nav-tab"
            onClick={() => onChangeTab(tab.id)}
            style={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              padding: '8px 0 6px',
              color: isActive ? 'var(--accent)' : 'var(--text-muted)',
              transition: 'color 0.15s',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Active indicator */}
            {isActive && (
              <div
                className="nav-indicator"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: '25%',
                  right: '25%',
                  height: 2,
                  borderRadius: 1,
                  background: 'var(--accent)',
                }}
              />
            )}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 20, position: 'relative' }}>
              <tab.Icon size={20} strokeWidth={2} />
              {tab.id === 'dashboard' && pendingInvitationCount > 0 && (
                <span
                  style={{
                    position: 'absolute',
                    top: -4,
                    right: -8,
                    minWidth: 16,
                    height: 16,
                    borderRadius: 8,
                    background: 'var(--accent)',
                    color: 'white',
                    fontSize: '0.5625rem',
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 4px',
                    lineHeight: 1,
                  }}
                >
                  {pendingInvitationCount > 9 ? '9+' : pendingInvitationCount}
                </span>
              )}
            </div>
            <span
              className="nav-label"
              style={{
                fontSize: '0.5625rem',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}

    </nav>
  );
}
